import React from 'react';
import "../css/about.css"
import interiror1 from "../assets/about1.jpeg"
import journeyImage from "../assets/about2.jpeg"
import Topbar from "../components/Topbar";
import Header from "../components/header";
import Footer from "../screen/Footer"; 
import Herolast  from "../screen/herolast";

export default function ACExpertsHero() {
  return (
    <>
        <Topbar/>
      <Header />
      {/* Hero Section */}
      <div className="hero-container">
        {/* Background Image Container */}
        <div className="background-image">
          {/* Optional overlay for better text readability */}
          <div className="background-overlay"></div>
        </div>
        
        {/* Content Overlay */}
        <div className="content-overlay">
          <div className="content-card">
            {/* Welcome Text */}
            <div className="welcome-section">
              <p className="welcome-text">WELCOME</p>
            </div>
            
            {/* Main Heading */}
            <h1 className="main-heading">Your Trusted AC Experts</h1>
          </div>
        </div>
      </div>

      {/* Who We Are Section */}
      <section className="who-we-are-section">
        <div className="container">
          <div className="section-header">
            <p className="section-subtitle">WHO WE ARE</p>
            <h2 className="section-title">Committed to Comfort and Quality AC Solutions</h2>
            <p className="section-description">
              At Krishna AC Service, we take pride in our exceptional service that has consistently delighted our clients in Surat. 
              Our skilled technicians have successfully resolved numerous AC issues, ensuring optimal performance and 
              customer satisfaction, making us a trusted partner for both residential and commercial air conditioning needs.
            </p>
          </div>
          <div className="section-image">
            <img src={interiror1} alt="Modern interior with AC installation" />
          </div>
        </div>
      </section>

      {/* Our Journey Section */}
      <section className="journey-section">
        <div className="container">
          <div className="journey-content">
            <div className="journey-text">
              <p className="journey-subtitle">OUR JOURNEY</p>
              <h2 className="journey-title">The Growth Story of Krishna AC Service</h2>
              <div className="journey-paragraphs">
                <p className="journey-paragraph">
                  Founded in Surat, Krishna AC Service began as a small startup with a 
                  vision to provide reliable air conditioning solutions. Over the years, we 
                  have expanded our team and services, establishing a strong reputation for 
                  quality and customer care, helping numerous clients beat the heat with 
                  efficient AC installations and repairs.
                </p>
                <p className="journey-paragraph">
                  Krishna AC Service has evolved significantly since its inception, becoming 
                  a trusted name in AC services within Surat, known for our dedication and 
                  expert craftsmanship.
                </p>
              </div>
            </div>
            <div className="journey-image">
              <img src={journeyImage} alt="Modern bedroom with AC installation" />
            </div>
          </div>
        </div>
      </section>

      {/* Our Commitment Section */}
      <section className="commitment-section">
        <div className="container">
          <div className="commitment-header">
            <p className="commitment-subtitle">OUR COMMITMENT</p>
            <h2 className="commitment-title">Mission and Values We Uphold</h2>
          </div>
          <div className="commitment-content">
            <div className="mission-column">
              <p className="column-subtitle">OUR MISSION</p>
              <h3 className="column-title">Delivering Excellence in Service</h3>
              <p className="column-description">
                Our mission at Krishna AC Service is to provide top-notch air 
                conditioning solutions that enhance the comfort of our customers while 
                maintaining transparency, integrity, and professionalism in all our 
                dealings.
              </p>
            </div>
            <div className="divider"></div>
            <div className="values-column">
              <p className="column-subtitle">OUR VALUE</p>
              <h3 className="column-title">Core Values We Believe In</h3>
              <p className="column-description">
                We believe in customer-centric service, reliability, and continuous 
                improvement. Our commitment to enhancing client satisfaction drives 
                us to deliver high-quality solutions and exceptional support in all our air 
                conditioning endeavors.
              </p>
            </div>
          </div>
        </div>
      </section>
       <Herolast  />
      <Footer  />
    </>
  );
}